import React, { Component } from 'react';

const Descargas = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-6">Resumen de Descarga</h1>
      <table className="table-auto border-collapse border border-gray-400 w-full">
        <thead>
          <tr className="bg-gray-200">
            <th className="border border-gray-400 px-4 py-2 text-left">Archivo</th>
            <th className="border border-gray-400 px-4 py-2 text-left">Descripción</th>
            <th className="border border-gray-400 px-4 py-2 text-left">Enlace</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-gray-400 px-4 py-2">ejemplo-M3x25.zip</td>
            <td className="border border-gray-400 px-4 py-2">Código fuente del módulo 3</td>
            <td className="border border-gray-400 px-4 py-2">
              <a
                href="/descargas/ejemplo-M3x25.zip"
                className="text-blue-600 underline"
                download
              >
                Descargar
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Descargas;
